import {observer} from 'mobx-react';
import FormRow from '../../../../../forms/FormRow';
import FormColumn from '../../../../../forms/FormColumn';
import FormNumberField from '../../../../../components/fields/FormNumberField';

function CreditNoteRefundOnOrderTotalResolutionPanel({subsectionForm, readOnly}) {
    return (
        <FormColumn>
            <FormRow>
                <FormNumberField
                    label="Porcentaje (%)"
                    field={subsectionForm.getFieldByName('percentage')}
                    width="100%"
                    disabled={readOnly}
                />
            </FormRow>
        </FormColumn>
    );
}

export default observer(CreditNoteRefundOnOrderTotalResolutionPanel);
